'use client';
import { Modal } from '@mantine/core';
import { usePathname } from 'next/navigation';

import { useGetUserQuery } from '@scaleup/frontend/api';
import { PlatformUser } from '@scaleup/models';
import {
  TermsWizardContextProvider,
  useTermsWizardContext,
} from './context';
import { TermsForm } from './terms-form';
import { Success } from './success';

const InnerComponent = () => {
  const { currentStep, show, setShow } = useTermsWizardContext();
  const pathname = usePathname();

  // Don't show on supplier intake pages or privacy policy page
  if (pathname?.includes('/supplier/intake') || pathname?.includes('/privacy-policy')) {
    return null;
  }

  const render = () => {
    switch (currentStep) {
      case 'terms':
        return <TermsForm />;
      case 'success':
        return <Success />;
      default:
        return null;
    }
  };

  return (
    <Modal
      classNames={{ body: 'bg-[#edf7fa] min-h-screen' }}
      fullScreen
      opened={show}
      closeOnEscape={false}
      closeOnClickOutside={false}
      withCloseButton={false}
      onClose={() => setShow(false)}
      zIndex={1000}
    >
      <div className="p-8 w-full">{render()}</div>
    </Modal>
  );
};

export const TermsWizard = () => {
  const { data: user, isLoading } = useGetUserQuery();

  if (isLoading || !user) {
    return null;
  }

  // Cast to PlatformUser to access preferences
  const platformUser = user as PlatformUser;

  // Check if user has already accepted terms
  const hasAcceptedTerms = platformUser.preferences?.acceptedTermsAndConditions;

  if (hasAcceptedTerms) {
    return null;
  }

  return (
    <TermsWizardContextProvider user={platformUser}>
      <InnerComponent />
    </TermsWizardContextProvider>
  );
};
